import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AsyncImportStatus, ImportStatus } from "../../models/domains/pbm/async-import/async-import-status";
import { AsyncImportRepository } from "../../repositories/pbm/async-import-repository";

@Injectable({ providedIn: "root" })
export class AsyncImportService {
    constructor(private asyncImportRepository: AsyncImportRepository) {
    }

    private asyncSotrage(): string[] {
        const data = localStorage.getItem('async-sotrage');
        if (!data) return []
        return JSON.parse(data);
    }

    createKey(importKey: string, helperKey: string): string {
        return `${importKey}#.#${helperKey}`;
    }

    getKey(key: string): string {
        const typed = this.asyncSotrage().find(x => x == key || x.includes(`#.#${key}`))
        if (!typed) return null;
        if (typed.includes('#.#')) {
            return typed.split('#.#')[0];
        }
        return typed;
    }
    removeKey(key: string): void {
        const store = this.asyncSotrage().filter(x => x != key)
        localStorage.setItem('async-sotrage', JSON.stringify(store));
    }

    addKey(key: string) {
        let store = this.asyncSotrage().filter(x => x != key);
        store.push(key);
        localStorage.setItem('async-sotrage', JSON.stringify(store));
    }
    async downloadFileSummary(key: string): Promise<any> {
        return this.asyncImportRepository.fileSummary(key);
    }

    checkStatus(key: string): Promise<AsyncImportStatus> {
        return this.asyncImportRepository.checkStatus(key)
    }

    registerConsult(key: string): Observable<AsyncImportStatus> {
        return new Observable((observer) => {
            let intervalHandler = setInterval(async () => {
                const status = await this.asyncImportRepository.checkStatus(key);
                try {
                    if ([ImportStatus.PROCESSED, ImportStatus.FAILED].includes(status.status)) {
                        clearInterval(intervalHandler);
                    }
                } catch (error) {
                    console.log(error);
                    clearInterval(intervalHandler);
                    observer.error('Erro na importação.');
                }
                observer.next(status);
            }, 5000);

            return {
                unsubscribe() {
                    clearInterval(intervalHandler);
                }
            };
        })
    }
}